module.exports = __webpack_public_path__ + "img/b89d527.jpg";